import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { FaSearch } from "react-icons/fa";
import Button from "../../Components/Button";
import TextInput from "../../Components/TextInput";
import { FormField } from "../../Components/FormField";
import SidebarField from "../../Components/SidebarField";
import LoaderContext from "../../Components/loader";
import CommonLayout from "../../Components/CommonLayout/CommonLayout";
import { FundingApi } from "../../App/api/Funding.apis";
import FinanceFundCard from "./FinanceFundCard";
import { toast } from "react-toastify";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ImagePreview from "../../Components/ImagePreview";
import DeleteFieldModal from "../../Components/Common/DeleteFieldModal";
import ReactQuill from "react-quill";

const FinancingFunding = () => {
  const [isVisible, setVisible] = useState(false);
  const [isError, setError] = useState(false);
  const [isView, setIsView] = useState(false);
  const [deleteFundId, setDeleteFundId] = useState("");
  const [viewData, setViewData] = useState("");
  const [currentItems, setCurrentItems] = useState("");
  const [allFunds, setAllFunds] = useState([]);
  const [deleteModal, setDeleteModal] = useState("");
  const { handleLoading } = useContext(LoaderContext);
  const [searchQuery, setSearchQuery] = useState("");
  const debounceTimeout = useRef(null);

  const getAllFunds = async () => {
    handleLoading(true);
    try {
      const res = await FundingApi.getAllFund();
      setAllFunds(res.data.data.financeAndFunding);
      // console.log("funds Data:",res.data.data.financeAndFunding);
    } catch (err) {
      console.log(err);
      // showBoundary(err);
    } finally {
      handleLoading(false);
      // setEditCategoryData(null);
      // setIsConfirm(false);
      // getAllCategories();
    }
  };
  // console.log("data funds:",allFunds);

  const onEdit = (fund) => {
    console.log("Edit fund id:", fund._id);
    setVisible(true);
    setCurrentItems(fund);
  };
  const onDelete = async (id) => {
    setDeleteFundId(id);
    setDeleteModal(true);
    console.log("Delete ID:", id);
  };

  const handleDeleteClose = () => {
    setDeleteModal(false);
  };

  const handleDelete = async () => {
    try {
      if (deleteFundId !== null) {
        const res = await FundingApi.deleteFund(deleteFundId);
        toast.success(`${res.data.message}`);
        getAllFunds();
      }
    } catch (err) {
      // console.log(err);
    } finally {
      handleDeleteClose();
    }
  };
  const onView = (fund) => {
    setIsView(true);
    setViewData(fund);
  };

  const handleSubmit = async (values) => {
    console.log("Form Values:", values);

    handleLoading(true);
    try {
      const res = currentItems?._id
        ? await FundingApi.updateFund(values, currentItems?._id)
        : await FundingApi.createFund(values);
      toast.success(currentItems?._id ? "Update" : "Created", " Successfully");
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form:", error);
    } finally {
      handleLoading(false);
      getAllFunds();
      setCurrentItems();
      setVisible();
    }
  };
  const handleSearch = useCallback((s) => {
    // console.log('Search at OrderCom', s);
    setSearchQuery(s);
  }, []);
  const handleFileUpload = (e, setFieldValue) => {
    const file = e.target.files[0];
    console.log("img file", file);
    console.log("img e", e);

    if (file) {
      // Check if file size exceeds 1MB
      const fileSizeInMB = file.size / 1024 / 1024;
      if (fileSizeInMB > 1) {
        setError("Please select an image smaller than 1MB.");
        setFieldValue("image", null);
        return;
      }

      // Clear error and set the file if size is valid
      setError("");
      setFieldValue("image", file);
    }
  };

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s.target.value);
      }, 1500);
    },
    [handleSearch]
  );

  const initialValues = {
    image: currentItems?.image || "",
    name: currentItems?.name || "",
    financeType: currentItems?.financeType || "",
    overview: currentItems?.overview || "",
    interestRate: currentItems?.interestRate || "",
    loanAmount: currentItems?.loanAmount || "",
    repaymentPeriod: currentItems?.repaymentPeriod || "",
    eligibilityCriteria: currentItems?.eligibilityCriteria || "",
    applicationProcess: currentItems?.applicationProcess || "",
    contactInfo: currentItems?.contactInfo || "",
    moreInfoLink: currentItems?.moreInfoLink || "",
  };

  const handleClose = () => {
    // setFile(null);
    // setPreview(null);
    setVisible(false);
    setCurrentItems();
    // setSubCategoryFields([]);
  };
  useEffect(() => {
    getAllFunds();
  }, []);

  return (
    <>
      <div className="p-5 mb-10 mr-10">
        <CommonLayout />
        <div className="flex justify-between items-center flex-wrap mb-2 p-5">
          <div className="border border-[--color--1] rounded-full px-3 py-1.5 text-xs bg-transparent w-fit flex justify-between items-center">
            <input
              type="search"
              placeholder="search..."
              // value={searchQuery}
              onChange={debouncedSearch}
              className="bg-transparent outline-none"
            />
            <FaSearch className="text-[--color--1]" />
          </div>
          <Button
            text="Add New"
            type="button"
            className="float-end"
            onClick={() => {
              setVisible(true);

              setCurrentItems();
              // subCategoryOptions();
            }}
          />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-4 m-4">
          {allFunds.map((fund, i) => {
            return (
              <FinanceFundCard
                fund={fund}
                onEdit={onEdit}
                onDelete={onDelete}
                onView={onView}
              />
            );
          })}
        </div>
        {isVisible && (
          <Formik
            initialValues={initialValues}
            //   validationSchema={FundingOpportunitySchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ values, handleChange, setFieldValue }) => (
              <Form className="w-full flex gap-0 flex-col bg-transparent py-5 px-3">
                <SidebarField
                  handleClose={handleClose}
                  title={
                    currentItems?._id
                      ? "Update Funding Opportunity"
                      : "Add New Funding Opportunity"
                  }
                  button1={
                    <Button text="Cancel" type="button" onClick={handleClose} />
                  }
                  button2={
                    <Button
                      text={currentItems?._id ? "Update" : "Add"}
                      type="submit"
                    />
                  }
                >
                  {/* Title */}
                  {/* Title */}
                  <div className="my-2">
                    {typeof values.image === "object" ? (
                      <ImagePreview file={values?.image} id="image" />
                    ) : (
                      <LazyLoadImage
                        src={
                          values.image ||
                          "https://storeedelivery.elluminatiinc.net/assets/img/default_images/category.png"
                        }
                        alt="category-item"
                        effect="blur"
                        wrapperProps={{
                          style: { transitionDelay: "1s" },
                        }}
                      />
                    )}

                    <span className="text-[12px]   flex w-full">
                      <label htmlFor="image-upload" className="w-full flex ">
                        <TextInput
                          name="image"
                          type="file"
                          placeholder="Choose File"
                          id="image-upload"
                          onChange={(e) => handleFileUpload(e, setFieldValue)}
                        />
                        <button
                          className="border px-5 cursor-pointer z-5 "
                          type="file"
                          id="image-upload"
                        >
                          Browse
                        </button>
                      </label>
                    </span>
                    <ErrorMessage
                      name="image"
                      component="div"
                      className="error"
                    />
                  </div>
                  {isError && (
                    <p className="text-red-500 text-sm mt-2">{isError}</p>
                  )}
                  <FormField
                    label="Title"
                    className={"mb-4"}
                    tooltip="Enter the funding opportunity title"
                  >
                    <TextInput
                      name="name"
                      type="text"
                      placeholder="Enter funding opportunity title"
                      value={values.name}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  {/* Type of Financing */}
                  <FormField
                    label="Type of Financing"
                    className={"mb-4"}
                    tooltip="Specify type of financing"
                  >
                    <TextInput
                      name="financeType"
                      type="text"
                      placeholder="e.g., Loan, Grant, Investment"
                      value={values.financeType}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="financeType"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  {/* Overview */}
                  <FormField
                    label="Overview"
                    tooltip="write a brief overview of item"
                  >
                    <div id="overview">
                      <ReactQuill
                        theme="snow"
                        value={values.overview}
                        onChange={(v) => setFieldValue("overview", v)}
                        // readOnly={true}
                      />
                    </div>

                    <ErrorMessage
                      name="overview"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  {/* Interest Rate */}
                  <FormField
                    label="Interest Rate"
                    className={"mb-4"}
                    tooltip="Specify the interest rate (if applicable)"
                  >
                    <TextInput
                      name="interestRate"
                      type="number"
                      placeholder="Enter interest rate"
                      value={values.interestRate}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="interestRate"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  {/* Loan Amount */}
                  <FormField
                    label="Loan/Grant Amount"
                    className={"mb-4"}
                    tooltip="Specify the maximum amount available"
                  >
                    <TextInput
                      name="loanAmount"
                      type="text"
                      placeholder="Enter loan or grant amount"
                      value={values.loanAmount}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="loanAmount"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  {/* Repayment Period */}
                  <FormField
                    label="Repayment Period"
                    className={"mb-4"}
                    tooltip="Specify duration for loan repayment (if applicable)"
                  >
                    <TextInput
                      name="repaymentPeriod"
                      type="text"
                      placeholder="Enter repayment period"
                      value={values.repaymentPeriod}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="repaymentPeriod"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  {/* Eligibility Criteria */}
                  <FormField
                    label="Eligibility Criteria"
                    className={"mb-4"}
                    tooltip="Specify requirements for applicants to qualify"
                  >
                    <div id="eligibilityCriteria">
                      <ReactQuill
                        theme="snow"
                        value={values.eligibilityCriteria}
                        onChange={(v) =>
                          setFieldValue("eligibilityCriteria", v)
                        }
                        // readOnly={true}
                      />
                    </div>
                    <ErrorMessage
                      name="eligibilityCriteria"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  {/* Application Process */}
                  <FormField
                    label="Application Process"
                    className={"mb-4"}
                    tooltip="Describe the application steps"
                  >
                    <div id="applicationProcess">
                      <ReactQuill
                        theme="snow"
                        value={values.applicationProcess}
                        onChange={(v) => setFieldValue("applicationProcess", v)}
                        // readOnly={true}
                      />
                    </div>
                    <ErrorMessage
                      name="applicationProcess"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  {/* Contact Info */}
                  <FormField
                    label="Contact Info"
                    className={"mb-4"}
                    tooltip="Enter contact email or phone number"
                  >
                    <TextInput
                      name="contactInfo"
                      type="text"
                      placeholder="Enter contact info"
                      value={values.contactInfo}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="contactInfo"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  {/* More Info Link */}
                  <FormField
                    label="More Info Link"
                    className={"mb-4"}
                    tooltip="Provide a link for detailed information"
                  >
                    <TextInput
                      name="moreInfoLink"
                      type="url"
                      placeholder="Enter a valid URL"
                      value={values.moreInfoLink}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="moreInfoLink"
                      component="div"
                      className="error"
                    />
                  </FormField>
                </SidebarField>
              </Form>
            )}
          </Formik>
        )}
      </div>
      {deleteModal && (
        <DeleteFieldModal
          isOpen={deleteModal}
          onClose={handleDeleteClose}
          onDelete={handleDelete}
        />
      )}
      {isView && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-10 flex items-center justify-center">
          <div className="w-[80%] max-w-2xl n-card p-4 rounded-lg shadow-lg bg-white">
            <div className="flex justify-between pb-2 border-b">
              <span className="text-lg font-bold">Loan Details</span>
              <span
                className="text-lg cursor-pointer"
                onClick={() => setIsView(false)}
              >
                X
              </span>
            </div>

            {/* Modal Image */}
            <div className="h-[300px] flex justify-center">
              <LazyLoadImage
                loading="lazy"
                src={viewData?.image}
                alt="Loan Image"
                className="object-cover transform transition-transform duration-300 cursor-pointer"
                onError={(e) =>
                  (e.target.src = "https://via.placeholder.com/300")
                }
              />
            </div>

            {/* Loan Details */}
            <div className="font-bold text-lg mt-1">{viewData?.name}</div>
            <span className="mt-2 px-2 mb-1 shadow border rounded-md">
              {viewData?.financeType}
            </span>

            <div className="flex gap-4 mt-1">
              <span>
                <strong>Interest Rate:</strong> {viewData?.interestRate}%
              </span>
              <span>
                <strong>Loan Amount:</strong> $
                {viewData?.loanAmount.toLocaleString()}
              </span>
              <span>
                <strong>Repayment Period:</strong> {viewData?.repaymentPeriod}
              </span>
            </div>

            <div className="mt-1">
              <strong>Overview:</strong>
              <p dangerouslySetInnerHTML={{ __html: viewData?.overview }} />
            </div>

            <div className="mt-1">
              <strong>Eligibility Criteria:</strong>
              <p
                dangerouslySetInnerHTML={{
                  __html: viewData?.eligibilityCriteria,
                }}
              />
            </div>

            <div className="mt-1">
              <strong>Application Process:</strong>
              <p
                dangerouslySetInnerHTML={{
                  __html: viewData?.applicationProcess,
                }}
              />
            </div>

            <div className="mt-1 flex gap-2">
              <strong>Contact Info:</strong>
              <p>{viewData?.contactInfo}</p>
            </div>

            <div className="mt-1">
              <a
                href={viewData?.moreInfoLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline"
              >
                More Info
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FinancingFunding;
